import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { getImage } from './utils';
import * as styles from './ServiceWrapper.css';

interface IServiceWrapperProps {
  isActive: boolean;
  children: React.ReactNode;
  isDisabled?: boolean;
  className?: string;
  onClick(): void;
}

export const ServiceWrapper = ({ isActive, isDisabled, children, className, onClick }: IServiceWrapperProps) => {
  return (
    <div
      {...mergeStyles(
        styles['container'],
        isActive && styles['container_active'],
        isDisabled && styles['container_disabled'],
        className,
      )}
      onClick={onClick}
    >
      {isActive && (
        <div className={styles['active_tick']}>
          <div dangerouslySetInnerHTML={getImage('activeTick')} />
        </div>
      )}
      {children}
    </div>
  );
};
